(async () => {
    const { Core } = await importModule('Core');

    customElements.define('collection-filter', class extends Core {
        render() {
            this.addEventListener('change', this._changeHandler.bind(this));
            this.querySelector("button").addEventListener('click',this.handleFilterAccordian.bind(this))
        }
        _changeHandler(e) {
            this.publish('filter:change');
            let elmId = $(e.target).parent().attr('for')
            localStorage.setItem('id','#'+elmId);

        }
        handleFilterAccordian(e){
            $(this).find("button").toggleClass('open');
            const isOpen = this.classList.contains('open');
            $(this).find("button").attr('aria-expanded') == 'false' ? $(this).find("button").attr('aria-expanded','true') : $(this).find("button").attr('aria-expanded','false');

        }
    })
})();
